import $ from 'jquery';
import { isNil } from 'lodash';
import {
  emptyChampionsClass,
  emptyChampionsMessageClassName,
  emptyChampionsMessageAttribute,
} from '../_helpers/constants';
import { getCalendar } from '../utils';

export default class TournamentCalendar {
  constructor(elm) {
    this.$element = $(elm);
  }

  async showCalendar(calendar) {
    const id = calendar.getAttribute('data-tournamentId');
    await getCalendar('/calendar/tournament/' + id);
  }

  checkEmptyChampions() {
    const items = $(emptyChampionsClass);
    if (!isNil(items)) {
      const itemsLength = items.length;
      if (itemsLength > 1) {
        let formattedMessage = '';
        const message = this.$element.data(emptyChampionsMessageAttribute);
        if (!isNil(message) && message !== '') {
          formattedMessage = message.replace(/\+/g, ' ');
          $(items).eq(0).html(formattedMessage);
          $(items).eq(0).addClass(emptyChampionsMessageClassName);
          $(items).eq(1).remove();
        }
      }
    }
  }

  init() {
    const calendarBtns = document.querySelectorAll('[js-tournament-calendar]');
    calendarBtns.forEach((calendar) => {
      calendar.addEventListener('click', async () => this.showCalendar(calendar));
    });
    this.checkEmptyChampions();
  }
}
